<template lang="pug">
#content.snap-content
  .overlay(@click="hide()")
  Marquee(:class="{ 'd-none': !whiteLabel }")
  toolBar
  .content-center
    .pagepanel
      .page-group
        template(v-if="$store.getters.language == 'cn'")
          cnContent
        template(v-else-if="$store.getters.language == 'vi'")
          viContent
        template(v-else-if="$store.getters.language == 'th'")
          thContent
        template(v-else-if="$store.getters.language == 'id'")
          idContent
        template(v-else-if="$store.getters.language == 'kr'")
          krContent
        template(v-else)
          enContent

  footerNav
</template>

<script>
import Marquee from "@/components/mobile/mainPanelControl/marquee";
import toolBar from "@/components/mobile/toolBar";
import footerNav from "@/components/mobile/footerNav";

import enContent from "@/components/mobile/rules/en/water-polo";
import cnContent from "@/components/mobile/rules/cn/water-polo";
import viContent from "@/components/mobile/rules/vi/water-polo";
import thContent from "@/components/mobile/rules/th/water-polo";
import idContent from "@/components/mobile/rules/id/water-polo";
import krContent from "@/components/mobile/rules/kr/water-polo";
import config from "@/config";

export default {
  components: {
    Marquee,
    toolBar,
    footerNav,
    enContent,
    cnContent,
    viContent,
    thContent,
    idContent,
    krContent
  },
  computed: {
    whiteLabel() {
      return config.whiteLabel == "1";
    }
  },
  methods: {
    hide(e) {
      var body = $("body");
      if (body.hasClass("snapjs-left")) {
        body.removeClass("snapjs-left");
      }
    }
  }
};
</script>